import DeleteOutline from "@mui/icons-material/DeleteOutlined";
import { IconButton, type IconButtonProps } from "@mui/material";

export type RaisedTrashIconButtonProps = Omit<IconButtonProps, "children" | "color" | "size">;

/**
 * Flat destructive trash button. Red outlined ring, soft red hover surface,
 * matches the inline node-tile delete affordance. No drop shadow.
 */
export default function RaisedTrashIconButton({ sx, ...props }: RaisedTrashIconButtonProps) {
	return (
		<IconButton
			size="small"
			{...props}
			sx={[
				{
					p: 0.75,
					width: 36,
					height: 36,
					minWidth: 36,
					borderRadius: "10px",
					backgroundColor: "#FFFFFF",
					color: "#E03030",
					border: "1px solid rgba(232, 80, 91, 0.35)",
					boxShadow: "none",
					transition: "background 0.15s ease, border-color 0.15s ease",
					"&:hover": {
						backgroundColor: "rgba(232, 80, 91, 0.08)",
						borderColor: "#E03030",
						boxShadow: "none",
					},
					"&.Mui-disabled": {
						backgroundColor: "#FFFFFF",
						color: "rgba(13, 31, 48, 0.30)",
						borderColor: "rgba(13, 31, 48, 0.12)",
						boxShadow: "none",
						opacity: 1,
					},
				},
				...(Array.isArray(sx) ? sx : sx ? [sx] : []),
			]}
		>
			<DeleteOutline sx={{ fontSize: 18 }} />
		</IconButton>
	);
}
